import Logging from '~app/core/logging';

import * as BusyActions from './busy';

const log = Logging.getLogger('app.actions.globe');

export const MORPH_GLOBE_REQUEST = 'MORPH_GLOBE_REQUEST';
export const MORPH_GLOBE_FINISHED = 'MORPH_GLOBE_FINISHED';

export const FLY_TO_REQUEST = 'FLY_TO_REQUEST';
export const FLY_TO_FINISHED = 'FLY_TO_FINISHED';

// Morphing

export function morphGlobe() {
  log.trace('morphing globe');
  return async (dispatch) => {
    const busyToken = dispatch(BusyActions.setBusyFlag('Globe.morph'));
    try {
      await dispatch(requestGlobeMorph());
    }
    finally {
      dispatch(BusyActions.clearBusyFlag(busyToken));
    }
  };
}

export function requestGlobeMorph() {
  return (dispatch, getState) => {
    // capture the resolve function outside of the promise so we can
    // call it from elsewhere in the application
    let outerResolve;
    const morphResolver = (mode) => {
      dispatch({
        type: MORPH_GLOBE_FINISHED,
        mode,
      });
      outerResolve();
    };
    const morphPromise = new Promise(innerResolve => {
      outerResolve = innerResolve;
    });
    dispatch({
      type: MORPH_GLOBE_REQUEST,
      morphPromise,
      morphResolver,
    });
    return morphPromise;
  };
}

export function completeGlobeMorph(mode) {
  return (_, getState) => {
    getState().globe.morphResolver();
  };
}

// Fly

export function flyTo(location, duration) {
  log.trace(`flyTo: ${location}, ${duration} sec`);
  return async (dispatch) => {
    await dispatch(requestFlyTo(location, duration));
  };
}

export function requestFlyTo(location, duration) {
  return (dispatch, getState) => {
    // capture the resolve function outside of the promise so we can
    // call it from elsewhere in the application
    let outerResolve;
    const flyToResolver = (flightComplete) => {
      dispatch({
        type: FLY_TO_FINISHED,
      });
      outerResolve();
    };
    const flyToPromise = new Promise(innerResolve => {
      outerResolve = innerResolve;
    });
    dispatch({
      type: FLY_TO_REQUEST,
      flyToPromise,
      flyToResolver,
      flyToLocation: location,
      flyToDuration: duration,
    });
    return flyToPromise;
  };
}

export function completeFlyTo(flightComplete) {
  return (_, getState) => {
    getState().globe.flyToResolver(flightComplete);
  };
}



// WEBPACK FOOTER //
// ./src/actions/globe.js